import * as Connector from 'shared/connectors/userConnector';
import { USER } from 'store/types';

const init = () => ({
  type: USER.GET_USERS_INIT,
});

export const success = data => ({
  type: USER.GET_USERS_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: USER.GET_USERS_FAILURE,
});

const getUsers = role => async dispatch => {
  dispatch(init());
  try {
    const { data } = await Connector.getUsers(role);
    dispatch(success(data));
  } catch (err) {
    dispatch(failure());
  }
};

export default getUsers;
